import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class UserAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // token = getTokenLocal();

  users = ApiRoutes.Users.AllUsers
  rolesAndPerms = ApiRoutes.User.AllRolesAndPerms
  userContactNumber = ApiRoutes.User.UserContactNumber
  userByUserId = ApiRoutes.User.UserByUserId
  updateGroup = ApiRoutes.User.UpdateGroup
  deleteUser = ApiRoutes.User.DeleteUser
  removeGroupDetails = ApiRoutes.User.RemoveGroupDetails
  getPossibleRoles = ApiRoutes.User.GetPossibleRoles
  getRoles = ApiRoutes.User.GetRoles
  updateRoles = ApiRoutes.User.UpdateRoles

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getCurrentLoggedInUser = (token: string) => {
    return this.instance({
      method: this.users.Method,
      url: this.users.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getRolesAndPermissionsInfo = (token: string) => {
    return this.instance({
      method: this.rolesAndPerms.Method,
      url: this.rolesAndPerms.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  updateUserContactNumber = (token: string, uid: any, contactNumber: any) => {
    return this.instance({
      method: this.userContactNumber.Method,
      url: this.userContactNumber.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { contact_number: contactNumber },
    })
  }

  getUserByUserId = (token: string, uid: any) => {
    return this.instance({
      method: this.userByUserId.Method,
      url: this.userByUserId.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  updateGroupDetails = (
    token: string | null,
    group_sk: any[],
    practice_sk: any[],
    uid: any,
  ) => {
    return this.instance({
      method: this.updateGroup.Method,
      url: this.updateGroup.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk,
        practice_sk,
        uid,
      },
    })
  }

  getPossibleRole = (token: string, uid: any) => {
    return this.instance({
      method: this.getPossibleRoles.Method,
      url: this.getPossibleRoles.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  getRole = (token: string, uid: any) => {
    return this.instance({
      method: this.getRoles.Method,
      url: this.getRoles.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  updateRole = (
    token: string | null,
    uid: any,
    new_role_cat: string,
    new_role_id: string,
  ) => {
    return this.instance({
      method: this.updateRoles.Method,
      url: this.updateRoles.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        uid,
        new_role_cat,
        new_role_id,
      },
    })
  }

  removeGroupDetail = (
    token: string | null,
    group_sk: any[],
    practice_sk: any[],
    uid: any,
  ) => {
    return this.instance({
      method: this.removeGroupDetails.Method,
      url: this.removeGroupDetails.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk,
        practice_sk,
      },
    })
  }

  deleteUserByUid = (token: string, uid: any) => {
    return this.instance({
      method: this.deleteUser.Method,
      url: this.deleteUser.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
